import type { KanbanTimeOff } from '@ts-tutor-kanban/interfaces'
import type { Pagination } from '@ts-common/interfaces'

import { useTutorKanbanStore } from '@stores/tutor-kanban'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

interface TimeOffsApiOptions {
  tutorId: string | number
  onStart?: () => void
  onSuccess?: (data: KanbanTimeOff[]) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

interface TimeOffsApiResponse {
  time_offs: KanbanTimeOff[]
  meta: Pagination
}

export const useTimeOffsApi = async (options: TimeOffsApiOptions): Promise<KanbanTimeOff[]> => {
  if (!options.tutorId) return []

  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.tutor-kanban.time-offs', { tutor_id: options.tutorId })

  const tutorKanbanStore = useTutorKanbanStore()

  options.onStart?.()
  tutorKanbanStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const response: TimeOffsApiResponse = data.data

    tutorKanbanStore.setTimeOffs(response.time_offs)
    tutorKanbanStore.setLoading(false)

    options.onSuccess?.(response.time_offs)

    return response.time_offs
  } catch (err: unknown) {
    console.error(err)
    tutorKanbanStore.setLoading(false)
    options.onError?.(err)

    return []
  } finally {
    options.onFinish?.()
  }
}
